import Link from "next/link";
import { VFC } from "react";

import { BreadCrumbsData } from "lib/type";

import { FaChevronRight } from "react-icons/fa";

type BreadCrumbsProps = {
  lists: BreadCrumbsData[] | undefined | null;
};

const BreadCrumbs: VFC<BreadCrumbsProps> = ({ lists }) => {
  if (!lists) {
    return null;
  }

  const breadCrumbsList = lists.map((list, index) => {
    const { string, path } = list;

    return (
      <li key={index} className="flex items-center">
        {lists.length - 1 !== index && path ? (
          <Link href={path} prefetch={false}>
            <a className="flex items-center whitespace-normal leading-tight underline">
              {string}
              <FaChevronRight className="mx-2 text-xs" />
            </a>
          </Link>
        ) : (
          <span className="whitespace-normal">{string}</span>
        )}
      </li>
    );
  });

  return (
    <ol className="container flex flex-wrap gap-2 overflow-x-auto whitespace-nowrap pt-6 pb-4 text-sm font-bold opacity-80">
      <li className="flex items-center">
        <Link href="/">
          <a className="flex items-center underline">
            トップ
            <FaChevronRight className="ml-2 text-xs" />
          </a>
        </Link>
      </li>
      {breadCrumbsList}
    </ol>
  );
};

export default BreadCrumbs;
